import { actionCreator } from '../../utils/actions';

export const appealEvent = actionCreator('Rides/APPEAL_EVENT');
export const appealEventClicked = actionCreator('Rides/APPEAL_EVENT_CLICKED');
export const cancelEventAppeal = actionCreator('Rides/CANCEL_APPEALING');



// WEBPACK FOOTER //
// ./src/components/Rides/actions.js